<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="DED">For Lisa, who started it all</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1ef83132